export const appKeys = {
  all: ['app'],
  inbox: () => [...appKeys.all, 'inbox']
} as const;
